'use client'
import { siteConfig } from '@/config/site'
import React, { useState, useEffect } from 'react'

export default function Image({ src: rawSrc, ...props }) {

  const [imageSrc, setImageSrc] = useState(rawSrc)

  useEffect(() => {

    const { hostname } = window.location
    const domain = hostname.match(/[^.]+\.[^.]+$/)?.[0]
    const assetUrl = siteConfig.isDynamicDomain
      ? `https://images.${domain}/web`
      : `https://images.mfans.live/web`

    const fullSrc = rawSrc.startsWith('http')
      ? rawSrc
      : `${assetUrl}${rawSrc}`

    setImageSrc(fullSrc)
  }, [rawSrc])

  return <img alt={props.alt || 'img'} src={imageSrc} {...props} />
}
